import { PaymentMethods } from "@/types/db/accounting";

export const adyenPaymentMethods = [
  PaymentMethods.METHOD_POS_ADYEN,
  PaymentMethods.METHOD_VISA,
  PaymentMethods.METHOD_GOOGLEPAY,
  PaymentMethods.METHOD_GOOGLEPAY_MASTERCARD,
  PaymentMethods.METHOD_GOOGLEPAY_VISA,
  PaymentMethods.METHOD_GOOGLEPAY_AMEX,
  PaymentMethods.METHOD_APPLEPAY,
  PaymentMethods.METHOD_APPLEPAY_AMEX,
  PaymentMethods.METHOD_APPLEPAY_MAESTRO,
  PaymentMethods.METHOD_APPLEPAY_MASTERCARD,
  PaymentMethods.METHOD_APPLEPAY_VISA,
  PaymentMethods.METHOD_MASTERCARD,
  PaymentMethods.METHOD_DISCOVER,
  PaymentMethods.METHOD_AMEX,
  PaymentMethods.METHOD_TWINT,
  PaymentMethods.METHOD_POST_CARD,
  PaymentMethods.METHOD_PAYPAL,
  PaymentMethods.METHOD_REKA,
  PaymentMethods.METHOD_CEMBRAPAY_INVOICE,
  PaymentMethods.METHOD_POWERPAY_INVOICE,
  PaymentMethods.METHOD_POSTFINANCE_EFINANCE,
  PaymentMethods.METHOD_PENDING,
  PaymentMethods.METHOD_CHINA_UNION_PAY,
  PaymentMethods.METHOD_MAESTRO,
  PaymentMethods.METHOD_IDEAL,
  PaymentMethods.METHOD_BANCONTACT,
  PaymentMethods.METHOD_BANCONTACT_MOBILE,
  PaymentMethods.METHOD_ALIPAY,
  PaymentMethods.METHOD_WECHATPAY_WEB,
  PaymentMethods.METHOD_DINERS,
  PaymentMethods.METHOD_JCB,
  PaymentMethods.METHOD_VPAY,
  PaymentMethods.METHOD_CART_BANCAIRE,
];
